import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

export class CustomRouteReuseStrategy implements RouteReuseStrategy {
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {}

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    const routes = [
      'home',
      'customer-history',
      'qcm',
      'result',
      'favorites',
      'dashboard',
      'evaluation/:auditId',
      'qcm/:auditId/result',
      'questions',
      'companies',
      'audits',
      'responses',
      'libraries',
      'recommendations',
      'categories',
      'staff-members',
      'login',
      'select-profile',
    ];

    const currentPath = curr.routeConfig?.path;
    const futurePath = future.routeConfig?.path;

    if (
      routes.includes(futurePath) ||
      (futurePath === '' && (currentPath === 'select-profile' || currentPath === 'login'))
    )
      return false;

    return true;
  }
}
